import { browserHistory } from 'react-router';
import { action, extendObservable } from 'mobx';
import { isRequired } from '../../../core/validations';
import FormService from '../../../core/services/FormService';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';
import InstructionVideoUploadService from './InstructionVideoUploadService';

class InstructionVideoFormService {
  form = new FormService();
  fetch = new FetchService();
  submit = new FetchService();

  constructor() {
    extendObservable(this, {
      instructionVideoId: null,
    });
    this.form.validations = {
      type: [isRequired],
      key: [isRequired],
    };
  }

  handleLoad = action(async (instructionVideoId) => {
    this.form.reset();
    this.form.setInitialValues({});
    this.instructionVideoId = instructionVideoId;

    if (instructionVideoId) {
      await this.fetch.fetch({ url: `/instruction-videos/${instructionVideoId}` });
      if (this.fetch.data) {
        this.form.setInitialValues(this.fetch.data);
      }
    }
  });

  handleEdit = action((locale) => {
    const currentInstruction = this.form.getValue('instructions').find((instruction) => instruction.locale === locale);
    InstructionVideoUploadService.init(this.form.getValue('id'), currentInstruction);
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }

    this.submit
      .fetch({
        method: 'post',
        url: '/instruction-videos',
        body: {
          ...this.form.getValues(),
        },
      })
      .then(() => {
        if (this.submit.data) {
          browserHistory.push(`/instruction-videos/${this.submit.data.id}`);
          NotificationService.addNotification('Instruction Video created successfully.', 'success');
          this.handleLoad(this.submit.data.id);
        }
        if (this.submit.error) {
          NotificationService.addNotification('Error creating Instruction Video.', 'error');
        }
      });
  });

  handleDelete = action((locale) => {
    const currentInstruction = this.form.getValue('instructions').find((instruction) => instruction.locale === locale);
    this.submit
      .fetch({
        method: 'put',
        url: `/instruction-videos/${this.instructionVideoId}`,
        body: {
          id: currentInstruction.id,
        },
      })
      .then(() => {
        if (this.submit.data) {
          NotificationService.addNotification('Instruction Video removed successfully.', 'success');
          this.handleLoad(this.instructionVideoId);
        }
        if (this.submit.error) {
          NotificationService.addNotification('Error removing Instruction Video.', 'error');
        }
      });
  });
}

const instructionVideoFormService = new InstructionVideoFormService();
export default instructionVideoFormService;
